import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';

class DriverForm extends Component {
  static validate = (values) => {
    const errors = {};
    const requiredFields = ['name','phone','key'];

    requiredFields.forEach((item) => {
      if (!values[item]) {
        errors[item] = 'Required';
      }
    });

    return errors;
  }

  renderTextField = props => (
    <TextField hintText={props.label} floatingLabelText={props.label} errorText={props.touched && props.error} {...props} fullWidth />
  );

  render() {
    const { handleSubmit, submitting } = this.props;
    const buttonText = (submitting) ? 'Saving...' : 'Save';

    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col s12">
            <Field name="name" label="Driver Name" component={this.renderTextField} />
          </div>
        </div>
        <div className="row">
          <div className="col s6">
            <Field name="phone" label="Phone" component={this.renderTextField} />
          </div>
          <div className="col s6">
            <Field name="key" label="Key" component={this.renderTextField} />
          </div>
        </div>
        <div className="row">
          <div className="col s4 right">
            <RaisedButton fullWidth onClick={handleSubmit} disabled={submitting}>{buttonText}</RaisedButton>
          </div>
        </div>
      </form>
    );
  }
}


export default reduxForm({
  form: 'driverForm',
  validate: DriverForm.validate
})(DriverForm);


// WEBPACK FOOTER //
// ./src/components/Drivers/Edit.js